module.exports = __webpack_public_path__ + "static/media/mobHelp.c94752e3.svg";